import { Setting } from "../../interfaces/setting.interface";
import http from "../axios"

export const getSetting = () => {
  return http.get(`/admin/settings`);
}

export const updateSetting = (setting:Setting) => {
  return http.patch(`/admin/settings`, setting);
}